import { LegalPageTemplate } from '../components/legal/LegalPageTemplate';
import { JsonLd } from '../components/seo/JsonLd';
import { PageSeo } from '../components/seo/PageSeo';
import { LEGAL_DOCUMENTS } from '../lib/legalContent';
import { buildLegalPageSchema } from '../lib/schema';
import { PRIVACY_META } from '../lib/seo';

export function PrivacyPolicyPage() {
  return (
    <>
      <PageSeo meta={PRIVACY_META} />
      <JsonLd
        data={buildLegalPageSchema('Privacy Policy', PRIVACY_META.path, '2026-05-26')}
      />
      <LegalPageTemplate
        title="Privacy Policy"
        effectiveDate="June 1, 2025"
        lastUpdated="May 26, 2026"
        content={LEGAL_DOCUMENTS.privacy}
      />
    </>
  );
}
